export function currency(value: number): string {
  return new Intl.NumberFormat("fr-CA", {
    style: "currency",
    currency: "CAD",
    currencyDisplay: "narrowSymbol",
  }).format(value);
}

export function date(value: number) {
  return new Intl.DateTimeFormat("fr-CA", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(value);
}

export function datetime(timestamp: number) {
  return new Intl.DateTimeFormat("fr-CA", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(timestamp);
}

export function integer(value: number): string {
  return new Intl.NumberFormat("fr-CA").format(value);
}

export function pluralize(n: number, singular: string, plural: string): string {
  return Math.abs(n) > 1 ? `${integer(n)} ${plural}` : `${n} ${singular}`;
}
